import React from "react";
import BrazeBannerSlot from "../Braze/BrazeBannerSlot";

export type BrazePlacementBannerProps = {
  placementId: string;
  className: string;
  ariaLabel: string;
  logLabel: string;
  onShowChange?: (show: boolean) => void;
  syncGlobalLayout?: boolean;
};

/** Generic inline Braze banner slot for rewards and other placements. */
const BrazePlacementBanner: React.FC<BrazePlacementBannerProps> = ({
  placementId,
  className,
  ariaLabel,
  logLabel,
  onShowChange,
  syncGlobalLayout = false,
}) => (
  <BrazeBannerSlot
    placementId={placementId}
    logLabel={logLabel}
    className={className}
    ariaLabel={ariaLabel}
    onShowChange={onShowChange}
    syncGlobalLayout={syncGlobalLayout}
  />
);

export default BrazePlacementBanner;
